import React from "react";
import Header from "./components/header"
import ServCardList from "./components/ServCardList"

function Services () {
    return (
        <div>
            <title>Our Service | PaladiumTechServiceLimited</title>
            <Header />
            <ServCardList />

        </div>
    )
}

export default Services;